import * as React from 'react';

interface ILayout {
  userBased: React.ReactNode;
  itemBased: React.ReactNode;
  historyBased: React.ReactNode;
}

export const Layout: React.FC<ILayout> = ({ itemBased, userBased, historyBased }) => (
  <>
    {itemBased}
    {userBased}
    {historyBased}
  </>
);
